import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  successSnackbarOpen: false,
  successSnackbarMessage: '',
  infoSnackbarOpen: false,
  infoSnackbarMessage: '',
  warningSnackbarOpen: false,
  warningSnackbarMessage: '',
  errorSnackbarOpen: false,
  errorSnackbarMessage: '',
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSuccessSnackbar: (state, action) => {
      state.successSnackbarOpen = action.payload.open;
      action.payload.message &&
        (state.successSnackbarMessage = action.payload.message);
    },
    setInfoSnackbar: (state, action) => {
      state.infoSnackbarOpen = action.payload.open;
      action.payload.message &&
        (state.infoSnackbarMessage = action.payload.message);
    },
    setWarningSnackbar: (state, action) => {
      state.warningSnackbarOpen = action.payload.open;
      action.payload.message &&
        (state.warningSnackbarMessage = action.payload.message);
    },
    setErrorSnackbar: (state, action) => {
      state.errorSnackbarOpen = action.payload.open;
      action.payload.message &&
        (state.errorSnackbarMessage = action.payload.message);
    },
    resetSnackbar: () => initialState,
  },
});

export const {
  setSuccessSnackbar,
  setInfoSnackbar,
  setWarningSnackbar,
  setErrorSnackbar,
  resetSnackbar,
} = snackbarSlice.actions;

// Selectors
export const selectSuccessSnackbar = (state) => {
  return {
    open: state.snackbar.successSnackbarOpen,
    message: state.snackbar.successSnackbarMessage,
  };
};
export const selectInfoSnackbar = (state) => {
  return {
    open: state.snackbar.infoSnackbarOpen,
    message: state.snackbar.infoSnackbarMessage,
  };
};
export const selectWarningSnackbar = (state) => {
  return {
    open: state.snackbar.warningSnackbarOpen,
    message: state.snackbar.warningSnackbarMessage,
  };
};
export const selectErrorSnackbar = (state) => {
  return {
    open: state.snackbar.errorSnackbarOpen,
    message: state.snackbar.errorSnackbarMessage,
  };
};

export default snackbarSlice.reducer;
